export const EVENT_NAME = 'INTERNALSTATS_OPEN_ALERT';
export const API_TRACKING_ENDPOINT = '/tracking/notification/email/open';



// WEBPACK FOOTER //
// ./app/tracking/events/internalstatsOpenAlert/constants.js